module.exports = __webpack_public_path__ + "static/media/bags-shopping.648e847d.svg";